import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { StorageService } from '../storage/storage-service.service';

@Injectable({
  providedIn: 'root'
})
export class MarketplaceService {
    constructor(
        private storage: StorageService,
        private api: ApiService
    ) {}

    setMerchant(data: any) {
        this.storage.setStorage('merchant', JSON.stringify(data));
    }

    getMerchant(): Promise<any> {
        return new Promise(async(reslove) => {
            this.api.getMyMerchant().subscribe(res => {
                // console.log(res);
                if(res.Code == 200) {
                   this.setMerchant(res.Results.MerchantId); 
                   reslove(res.Results);
                } else {
                    reslove({MerchantId: null});
                }
            }, err => {
                console.error(err);
                reslove(null);
            });
        });
    }

    isOwnerMerchant(merchantId: any) {
        return new Promise(async(reslove) => {
            let merchant = await this.getMerchant();
            let MerchantId = merchant ? merchant.MerchantId : null;
            let isOwner = MerchantId == merchantId ? true : false;
            reslove({isOwner: isOwner})
        });
    }

    getMerchantInfo(merchantId: any): Promise<any> {
        return new Promise((reslove) => {
          this.api.getMarketPlaceMerchantInfo(merchantId).subscribe(res => {
            if(res.Code == 200) {
              reslove(res.Results);
            } else {
              console.error(res);
              reslove('');
            }
          }, err => {
            console.error(err);
            reslove('');
          });
        });
      }
}